import { Filter } from '../../../models';

export class VisualizacaoStorage {
    filter: Filter;
    filterValues: Map<string, any>;
    filterSearch: string;
    currentPage: number;
    order: any[];
    scrollerStartPosition: number;

    constructor(filter: Filter, filterSearch = '', currentPage = 0, order = [], scrollerStartPosition = 0) {
        this.filter = filter;
        this.filterValues = new Map();
        this.filterSearch = filterSearch;
        this.currentPage = currentPage;
        this.order = order;
        this.scrollerStartPosition = scrollerStartPosition;
    }
}
